<template>
    <div v-if="fields" @click="onClick()" ref="icon-element"
      class="img-icon" :class="{ clickable: clickable }"
      >
        <div class="image-wrapper">
          <img
            :src="fields.iconUrl"
            :alt="fields.iconAlt"
        />
        </div>
        <div class="mt-3 info--text name">{{ fields.name }}</div>

        <div v-if="fields.overlayText" class="img-icon-overlay" :class="{ hide: hide }">
          <div class="mb-1 info--text name">{{ fields.name }}</div>
          <span>{{ fields.overlayText }}</span>
        </div>

        <hidden-btn
          v-if="fields.button"
          :btn-id="fields.button.sys.id"
          ref="btn"
      />
    </div>
</template>

<script>
import HiddenBtn from '@/components/snippets/hidden-btn'
export default {
  name: 'IconTile',
  data: function () {
    return {
      hide: true,
      clickable: false
    }
  },
  components: {
    HiddenBtn
  },
  props: {
    fields: {
      type: Object,
      required: true
    }
  },
  mounted: function () {
    const specifiedElement = this.$refs['icon-element']

    if (this.fields.button || this.fields.overlayText) {
      this.clickable = true
    }

    document.addEventListener('click', (event) => {
      var isClickInside = specifiedElement.contains(event.target)

      if (!isClickInside) {
        this.hide = true
      }
    })
  },
  methods: {
    onClick () {
      if (this.$refs.btn) {
        this.$refs.btn.click()
      } else if (this.fields.overlayText) {
        this.hide = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../styles/variables';

.image-wrapper {
  height:70px;
  width:70px;
  display:flex;

  img {
    max-width: 100%;
    display: block;
    margin: 0 auto;
    object-fit: contain;
  }
}

.img-icon {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;

    .name {
        max-width: 80%;
        font-weight: $font-weight-semi-bold;
    }

    .img-icon-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border: 2px solid #91db04;
        color: #007bbd;
        background: white;
        border-radius: 4px;
        margin: 0 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        &.hide {
          display: none;
        }

        .info--text {
          color: #007bbd !important;
        }
    }
}
</style>
